import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

export const toast = useToast({
    position: 'bottom-left'
});
